import { isNonEmptyString } from "@/utils";
import { Box } from "@mui/material";

export type ImageCenteredProps = {
  src?: string;
  alt?: string;
  title?: string;
  width?: string;
  height?: string;
};

const ImageCentered: React.FC<ImageCenteredProps> = ({
  src,
  alt,
  title,
  width,
  height,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "stretch",
      }}
    >
      {isNonEmptyString(src) ? (
        <img
          src={src}
          alt={alt}
          title={title}
          loading="lazy"
          style={{
            width: width || "100%",
            height: height || "auto",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
      ) : undefined}
    </Box>
  );
};

export default ImageCentered;
